import React from "react";

const TermsAndConditionsEn = () => {
  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      <h1 className="text-center text-3xl font-bold mb-6">
        TERMS AND CONDITIONS OF USE
      </h1>
      <p className="text-center text-lg mb-6">
        ANANAS SOLUTIONS – A product of Ananas Acti-Solutions Inc.
      </p>
      <p className="text-center mb-4">
        <strong>Last updated: October 2, 2025</strong>
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
        <p>
          These Terms and Conditions (“Terms”) govern your access to and use of
          the website, services, and platforms operated under the brand{" "}
          <strong>ANANAS SOLUTIONS</strong>, a product of{" "}
          <strong>Ananas Acti-Solutions Inc.</strong> (“we”, “our”, “us”). By
          using our services, you agree to be bound by these Terms. If you do
          not agree, you must discontinue use of our services.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. Changes</h2>
        <p>
          We reserve the right to amend these Terms at any time, without prior
          notice. The latest version is always published on our site. Continued
          use constitutes acceptance of the revised Terms.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. Intellectual Property</h2>
        <p>
          All content, trademarks, logos, text, images, videos, and features on
          the site are protected by copyright, trademark, and other applicable
          laws and remain the exclusive property of{" "}
          <strong>Ananas Acti-Solutions Inc.</strong> or its licensors.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">4. User Accounts</h2>
        <p>
          To use certain features, you may be required to create an account. You
          are responsible for maintaining the confidentiality of your login
          credentials, providing accurate information, and all activities that
          occur under your account. Misuse or fraudulent activity may result in
          suspension or termination of your account.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          5. Payments and Subscriptions
        </h2>
        <p>
          All purchases and subscriptions through our services are subject to
          the terms displayed at the time of the transaction. Payments are
          processed by authorized providers (e.g., Stripe). You agree that
          taxes, service charges, and applicable fees may be added to the listed
          price. Unless required by law, payments are non-refundable.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          6. Third-Party Products and Services
        </h2>
        <p>
          Some products or services may be provided by third parties. We are not
          responsible for their quality, legality, safety, or compliance. Any
          disputes must be addressed directly with the third-party provider or
          seller.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">7. Acceptable Use</h2>
        <p>
          You agree not to use our services for unlawful, defamatory,
          fraudulent, or harmful purposes. Any attempt to hack, reverse
          engineer, or exploit security vulnerabilities is strictly prohibited.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">8. Data Protection</h2>
        <p>
          By using our services, you consent to the collection and processing of
          certain personal data in accordance with our Privacy Policy. Your data
          may be processed in Canada or any country where we operate.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          9. Limitation of Liability
        </h2>
        <p>
          To the maximum extent permitted by law,{" "}
          <strong>Ananas Acti-Solutions Inc.</strong> disclaims all liability
          for direct, indirect, incidental, or consequential damages resulting
          from the use of our services. Services are provided “as is,” without
          warranties of accuracy, completeness, or availability.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">10. Force Majeure</h2>
        <p>
          We shall not be liable for delays or failures caused by events beyond
          our reasonable control, including but not limited to natural
          disasters, major outages, cyberattacks, labor disputes, or government
          actions.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          11. Governing Law and Jurisdiction
        </h2>
        <p>
          These Terms are governed by the laws of Quebec and Canada. Any
          disputes will be submitted to the exclusive jurisdiction of the courts
          of the judicial district of Montreal, Quebec.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">12. Contact</h2>
        <p>
          If you have any questions, please contact us at:{" "}
          <a
            href="mailto:privacy@ananassolutions.com"
            className="text-blue-500 underline"
          >
            privacy@ananassolutions.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditionsEn;
